<template lang="pug">
.event-details
  .time
    span {{ event.startTime }}
    span(v-if="event.endTime")  - {{ event.endTime }}
    span(v-if="event.location")  @ {{ event.location }}
  .event-name {{event.title}}
  .event-desc(v-html="__(event.subtitle, 'auto')")
  .sponsor(v-if="event.logo")
    span.presented-by {{ __('Presented by', eventNamespace) }}
    DynamicMedia.logo(:config="event.logo" :contain="true")
  .replay(v-if="event.replayLink")
    .btn-container
      RogueButton(:link="event.replayLink" width="full" ) {{ __('Replay', eventNamespace) }}
  .replay(v-else-if="event.link")
    .btn-container
      RogueButton(:link="event.link" width="full" :new-tab="event.linkNewTab" :color="'red'" :disabled="event.linkDisabled") {{ __(event.linkText, 'auto') }}
</template>
<script setup lang="ts">
import { eventNamespace } from '../../js/constants'

const props = withDefaults(defineProps<{
  event?: object
}>(), {
  event: () => ({}),
})

</script>
<style lang="scss" scoped>
.event-details {
  display: grid;
  border-bottom: 1px solid $color-gray-light;
  margin-bottom: $space-s;
  padding-bottom: $space-s;
  // Mobile layout
  grid-template-areas:
  "time title"
  "sponsor sponsor"
  "desc desc"
  "replay replay";

  // Add padding
  row-gap: $space-xxxs;
  column-gap: $space-s;

  // Time is set to 100px, let title take the rest of the space
  grid-template-columns: 100px 1fr;

  // Two rows on tablet / desktop
  @include not-mobile(){
    grid-template-columns: 1.5fr 2fr 1fr 1fr;
    grid-template-areas:
        "time title sponsor replay"
        "time desc sponsor replay";
  }
}

.time {
  grid-area: time;
  font-weight: $weight-bold;
}

.event-name {
  grid-area: title;
  font-weight: $weight-bold;
}

.event-desc {
  grid-area: desc;
  font-size: $size-xs;
}

.sponsor {
  grid-area: sponsor;
  display: flex;
  font-style: italic;
  align-items: center;

  .presented-by {
    font-size: $size-xs;
  }

  .logo {
    margin-left: $space-s;
    width: 220px;
    height: 40px;
  }

  @include not-mobile(){
    display: block;
    .logo {
      margin-left: 0;
    }
  }
}
.replay{
  grid-area: replay;
  display: flex;
  justify-content: flex-end;

  .btn-container {
    width: 100%;
  }

  @include not-mobile(){
    .btn-container{
      max-width: 100px;
    }
  }
}

</style>
